import React, { useEffect, useState } from "react";
import { Typography, Card, Row, Col } from "antd";
import { Link } from "react-router-dom";
import "./Blog.css";
import { useData } from "../../contexts/DataContext";
import { fetchBlogs } from "../../services/ApiService";

const { Title, Paragraph } = Typography;

const Blogs: React.FC = () => {
  const { state, dispatch } = useData();
  const [columns, setColumns] = useState<number>(1);

  useEffect(() => {
    if (!state.blogs) {
      fetchBlogs(dispatch);
    }

    const updateColumns = () => {
      const screenWidth = window.innerWidth;
      if (screenWidth >= 1100) {
        setColumns(3);
      }  else if (screenWidth >= 500) {
        setColumns(2);
      } else {
        setColumns(1);
      }
    };

    updateColumns();
    window.addEventListener("resize", updateColumns);

    return () => {
      window.removeEventListener("resize", updateColumns);
    };
  });

  const arrangeIntoColumns = () => {
    const columnsArray: any[] = Array.from({ length: columns }, () => []);
    state.blogs?.forEach((blog: any, index: number) => {
      const shortestColumnIndex = columnsArray.reduce(
        (acc, cur, i) => (cur.length < columnsArray[acc].length ? i : acc),
        0
      );
      columnsArray[shortestColumnIndex].push(blog);
    });
    return columnsArray;
  };

  return (
    <div style={{ padding: "16px"}}>
      {state.blogs && (
        <Row gutter={[16, 16]} justify={"center"}>
          {arrangeIntoColumns().map((column, columnIndex) => (
            <Col key={columnIndex} xs={24} sm={12} md={8} style={{maxWidth:"500px", padding:"2%"}} >
              {column.map((blog: any) => (
                <Link
                  to={`/blog/${blog.blog_url_path}`}
                  key={blog.id}
                >
                  <Card
                    hoverable
                    style={{
                      display: "block",
                      marginBottom: "16px",
                    }}
                    cover={
                      <img
                        alt={blog.Title}
                        src={`${state.baseApiPath}${blog.KeyImage.formats.small.url}`}
                      />
                    }
                  >
                    <Title level={3}>{blog.Title}</Title>
                    <Paragraph>{blog.Description}</Paragraph>
                  </Card>
                </Link>
              ))}
            </Col>
          ))}
        </Row>
      )}
    </div>
  );
};

export default Blogs;
